export function dictById(items, getKey) {
  return items.reduce((acc, item) => {
    const key = getKey(item);
    acc[key] = item;

    return acc;
  },{});
}